import Root from './src/containers/Root'
import {register} from './src/helpers/events.js';
import {addLocale} from './src/helpers/locale.js';
import * as actions from './src/actions/options.action.js';
import * as ui_actions from './src/actions/ui.action.js';
import * as toc from './src/actions/toc.action';
import {pushPath} from 'redux-simple-router';
import {OdinConcat} from '@chegg/odin-concat';
import {syncReduxAndRouter} from 'redux-simple-router'
import {ViewTypes} from './src/reducers';
import {ACCOUNT_OK, ACCOUNT_SUSPICIOUS, ACCOUNT_FLAGGED} from './src/modules/apiWrapper.js';
import {initRouteListener} from './src/modules/routeListener.js';
import setupStore from './src/store/setupStore.js';

import React, {dom} from './src/helpers/react';
const render = dom.render;
const AccessState = {ACCOUNT_OK, ACCOUNT_SUSPICIOUS, ACCOUNT_FLAGGED};

export function getPlayer(options) {
    let {
        store,
        history,
        router
    } = setupStore(options);
    initRouteListener(store);
    register(options);
    syncReduxAndRouter(history, store);

    render(
        <Root store={store} routes={router.routes} history={history} />,
        options.target
    );

    return {
        store : store,
        show : function(){
            store.dispatch(actions.show());
        },
        hide : function(){
            store.dispatch(actions.hide());
        },
        addEvents : function(opts){
            register(opts);
        },
        openProblem : function(chapter, problem){
            pushPath(router.buildRoute('problem',{chapter,problem}));
        },
        toggleFullscreen : function(){
            store.dispatch(ui_actions.toggleFullscreen());
        },
        enterFullscreen : function(){
            store.dispatch(ui_actions.enterFullscreen());
        },
        leaveFullscreen : function(){
            store.dispatch(ui_actions.leaveFullscreen());
        },
        setOptions : function(opts){
            store.dispatch(actions.setAppOptions(opts));
        }
    };
}

export {
    addLocale,
    ViewTypes
}

global.TBSPlayer = {
    getPlayer,
    actions : {...actions,...toc},
    setRootURL : function(url){
        OdinConcat.setBaseURL(url);
    },
    ViewTypes,
    addLocale,
    AccessState
};
global.Odin = OdinConcat.Promise;



// WEBPACK FOOTER //
// ./index.js